/**
 * Project wide custom types.
 */

/**
 * App breakpoints
 */

export const Breakpoints = {
  base: 0,
  sm: 576,
  md: 800,
  lg: 1024,
  xl: 1400,
  xxl: 1600,
  fhd: 1920,
} as const;

/**
 * Breakpoint union keys and values
 */
export type Breakpoint = (typeof Breakpoints)[keyof typeof Breakpoints];
export type BreakpointKeys = keyof typeof Breakpoints;

/**
 * Size abbreviations
 */
export const Sizes = {
  base: 'base',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl',
  fhd: 'fhd',
} as const;

/**
 * Size union values
 */
export type Size = (typeof Sizes)[keyof typeof Sizes];

/**
 * Fields with different size properties/values
 */
export type SizeFields<T> = {
  [key in Size]?: T;
};
